interface IconProps {
  size?: number;
  height?: number;
  width?: number;
  fill?: string;
}

const USDTIcon: React.FC<IconProps> = ({
  size = 32,
  height = size,
  width = size,
  fill = "#53AE94",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 0C24.8343 0 32 7.16567 32 16C32 24.8343 24.8343 32 16 32C7.16567 32 0 24.8387 0 16C0 7.16133 7.16567 0 16 0Z"
        fill={fill}
      />
      <path
        d="M17.9769 13.8672V11.4859H23.4218V7.85742H8.59943V11.4859H14.0443V13.8629C9.62062 14.0671 6.29199 14.9405 6.29199 15.9921C6.29199 17.0437 9.62062 17.9172 14.0443 18.1214V25.7477H17.9813V18.1214C22.3963 17.9172 25.7162 17.0437 25.7162 15.9921C25.7162 14.9405 22.3963 14.0671 17.9813 13.8629M17.9813 17.4739C17.8683 17.4783 17.2991 17.513 16.0302 17.513C15.0133 17.513 14.3007 17.4826 14.0486 17.4696C10.1421 17.3001 7.22192 16.6179 7.22192 15.8053C7.22192 14.9927 10.1377 14.3104 14.0486 14.1366V16.796C14.305 16.8134 15.0351 16.8569 16.0476 16.8569C17.2599 16.8569 17.8727 16.8047 17.9856 16.796V14.1366C21.8879 14.3104 24.7993 14.9927 24.7993 15.8053C24.7993 16.6179 21.8879 17.3001 17.9856 17.4739"
        fill="white"
      />
    </svg>
  );
};

export default USDTIcon;
